/* eslint-disable max-len */
import { useLocation, useOutletContext, useParams, useSearchParams } from "react-router-dom";
import LotTabHeader from "./lotTabHeader";
import LotTable from "./timedAuction/lotTable";
import { dataService } from "../../../../services/dataService";
import { useCallback, useEffect, useState } from "react";
import ToastMeassage from "../../../../CommonComponent/toastMeasseage";
import LiveLotTable from "./liveAuction/LotTable";
import ErrorMessage from "../../../../CommonComponent/errorMessage";
import uuid from "react-uuid";
import { Storage } from "aws-amplify";
import config from "../../../../config";
import { sanitizeFileName } from "../../../../utils/sanitizeFileName";
import scrollToTop from "../../../../CommonComponent/scrollToTop";

export default function Lots() {
    const outletContext = useOutletContext();
    const { lots, auctionData, lotInfo, fetchHandler, setSuccessMessage, handleSearch, handleSort, currentSortColumn,
        searchParams, loadLots, isSearched, uploadedFileName, setUploadedFileName, setCurrentSortColumn,
        showImportModal, setShowImportModal, importLoader, setImportLoader, setSearchParams, setExportBtnloading, exportBtnLoading,
        showExoprtToastMsg, setShowExportToastMsg, handleView, setLoadLots,
        setShowExportModel, showExportModel, isReorderLotModalOpen, setIsReorderLotModalOpen, lotDetailsFromSocket, isSocket, loading } = outletContext;

    const [searchValue, setSearchValue] = useState(searchParams.get('search') !== null ?
        decodeURIComponent(searchParams.get('search')) : '')
    const [deleteLotModal, setDeleteLotModal] = useState(false);
    const [loader, setLoader] = useState(false);
    const [showErrorToastMsg, setShowErrorToastMsg] = useState(false)

    const location = useLocation();
    const [liveLots, setLiveLots] = useState([]);
    const { id, uid } = useParams();

    // Handler for successful reorder
    const handleReorderSuccess = (message) => {
        setShowExportToastMsg(message);
        setTimeout(() => {
            setShowExportToastMsg('')
        }, 4000);

        // Refresh the lots data
        if (auctionData.auction_type === 'live') {
            fetchLiveLotsHandler()
        } else {
            fetchHandler()
        }
    };

    // Handler for reorder errors
    const handleReorderError = (message) => {
        setShowErrorToastMsg(message);
        setTimeout(() => {
            setShowErrorToastMsg('')
        }, 4000);
    };


    /**
         * The function `handleImportFile` is used to handle the import of a CSV file, store it in a
         * specific location in an S3 bucket, and then call a data service to import the lot data from the
         * CSV file.
         */
    const handleImportFile = async (e) => {
        e.preventDefault();
        setImportLoader(true)
        let fileName = '';
        fileName = await Storage.put(`DomainName/Auctions/lots/${uuid()}/${sanitizeFileName(uploadedFileName[0]?.name)}`, uploadedFileName[0], {
            contentType: uploadedFileName[0].type,
        })
        let body = {
            csv_url: `${config.Storage.CDN}${fileName.key}`,
            auction_id: uid
        }
        const data = await dataService.ImportLot(body)
        setShowImportModal(false)
        setImportLoader(false)
        setUploadedFileName('')
        scrollToTop();
        if (data.error) {
            setShowErrorToastMsg('CSV import unsuccessful due to error')
            setTimeout(() => {
                setShowErrorToastMsg('')
            }, 3500);
        }
        else {
            setShowExportToastMsg('CSV import was successful')
            handleView()
            if (auctionData.auction_type === 'live') {
                fetchLiveLotsHandler()
            } else {
                fetchHandler()
            }
            setTimeout(() => {
                setShowExportToastMsg('')
            }, 3500);
        }
    }

    const fetchLiveLotsHandler = useCallback(async (limit = 10) => {
        let endpoint = `?auction_id=${uid}&per_page=${limit}`
        if (searchParams.get('sort') !== null) {
            endpoint += `&sort_by=${String(searchParams.get('key'))}&sort_order=${String(searchParams.get('order'))}`
        }
        if (searchParams.get('search') !== null) {
            endpoint += `&search_keyword=${searchParams.get('search')}`
        }
        if (searchParams.get('lotExport') !== null) {
            endpoint += `&export=true`
        }
        const response = await dataService.LotList(endpoint, true);
        if (response.error === false) {
            setLiveLots(response.data);
            setExportBtnloading(false)
            setShowExportModel(false)
            let params = Object.fromEntries(searchParams);
            if (response.data.csv_url) {

                window.location.href = response.data.csv_url;

                delete params.lotExport
                setSearchParams({ ...params })
                setShowExportToastMsg('Export complete')
                setTimeout(() => {
                    setShowExportToastMsg('')
                }, 4000);
            }
            else if (response.data.csv_error) {
                delete params.lotExport
                setSearchParams({ ...params })
                setShowErrorToastMsg('Export failed')

                setTimeout(() => {
                    setShowErrorToastMsg('')
                }, 4000);
            }
        }
        setLoadLots(false);
    }, [location, searchParams])

    useEffect(() => {
        setSearchValue(
            searchParams.get('search')
                ? decodeURIComponent(searchParams.get('search'))
                : ''
        );
    }, [location.search]);

    const handleDelete = async (lot_number) => {
        setLoader(true);
        const body = {
            "auction_id": auctionData.auction_id,
            "lot_number": parseInt(lot_number),
        }
        const response = await dataService.deleteLot(body);
        setLoader(false);
        setDeleteLotModal(false);
        if (response.error === false) {
            setShowExportToastMsg(response.data?.message || 'Lot successfully deleted');
            setTimeout(() => {
                setShowExportToastMsg('')
            }, 4000);
            fetchHandler();
            handleView();
        } else {
            const errorMsg = response.message?.data?.message || 'Something went wrong, please try again'
            setShowErrorToastMsg(errorMsg)
            setTimeout(() => {
                setShowErrorToastMsg('')
            }, 4000);
        }
    }

    const deleteLiveLots = async (lot_id) => {
        setLoader(true);
        const body = {
            "auction_id": auctionData.auction_id,
            "lot_id": lot_id,
        }
        const response = await dataService.deleteLot(body, true);
        setLoader(false);
        setDeleteLotModal(false);
        if (response.error === false) {
            setShowExportToastMsg('Lot successfully deleted');
            setTimeout(() => {
                setShowExportToastMsg('')
            }, 4000);
            fetchLiveLotsHandler();
            handleView();
        } else {
            if (response.message && response.message?.data?.message == "Auction not in draft state") {
                setShowErrorToastMsg('Auction not in draft state')
                handleView();
            } else {
                setShowErrorToastMsg('Something went wrong, please try again')
            }
            setTimeout(() => {
                setShowErrorToastMsg('')
            }, 4000);
        }
    }

    const handleLiveSort = (e, key) => {
        let params = Object.fromEntries(searchParams);
        if (searchParams.get('sort') === false || searchParams.get('sort') === null) {
            params['sort'] = 'true'
            params['key'] = `${key}`
            params['order'] = `ascending`
            setCurrentSortColumn({
                key: key,
                order: 'asc'
            });
        } else {
            if (searchParams.get('key').includes(key)) {
                if (searchParams.get('order') === 'ascending') {
                    params['order'] = `descending`
                    setCurrentSortColumn({
                        key: key,
                        order: 'dsc'
                    });
                } else {
                    params['order'] = `ascending`
                    setCurrentSortColumn({
                        key: key,
                        order: 'asc'
                    });
                }
            }
            else {
                params['key'] = key
                params['order'] = `ascending`
                setCurrentSortColumn({
                    key: key,
                    order: 'asc'
                });
            }
        }
        setSearchParams({ ...params })
    }

    useEffect(() => {
        if (Object.keys(auctionData).length > 0 && auctionData?.auction_type == "live") {
            fetchLiveLotsHandler()
        }
    }, [auctionData, searchParams])


    return (
        <div
            className="hidden opacity-100 transition-opacity duration-150 ease-linear data-[te-tab-active]:block"
            id="tabs-profile3"
            role="tabpanel"
            data-te-tab-active
            aria-labelledby="tabs-profile-tab3">
            {/* <!-- search filter export content --> */}
            <LotTabHeader handleSearch={handleSearch} searchParams={searchParams}
                loadLots={loadLots}
                setSearchParams={setSearchParams}
                searchValue={searchValue} setSearchValue={setSearchValue}
                lotInfo={auctionData?.auction_type == "live" ? liveLots : lotInfo} auctionData={auctionData}
                handleImportFile={handleImportFile} uploadedFileName={uploadedFileName}
                setUploadedFileName={setUploadedFileName} showImportModal={showImportModal}
                setShowImportModal={setShowImportModal} importLoader={importLoader} setImportLoader={setImportLoader}
                setIsReorderLotModalOpen={setIsReorderLotModalOpen} isReorderLotModalOpen={isReorderLotModalOpen}
                setExportBtnloading={setExportBtnloading} exportBtnLoading={exportBtnLoading}
                setShowExportModel={setShowExportModel} showExportModel={showExportModel}
                // Add these new props for reorder functionality
                lots={auctionData?.auction_type === "live" ? liveLots.data : lots}
                onReorderSuccess={handleReorderSuccess}
                onReorderError={handleReorderError}
            />
            {showExoprtToastMsg != '' && <ToastMeassage message={showExoprtToastMsg} />}
            {showErrorToastMsg != '' && <ErrorMessage uploadErrorMessage={showErrorToastMsg} />}

            {/* <!-- table content --> */}
            {Object.keys(auctionData).length > 0 && (auctionData?.auction_type !== "live" ?
                <LotTable lots={lots} fetchHandler={fetchHandler}
                    handleSearch={handleSearch} handleSort={handleSort}
                    currentSortColumn={currentSortColumn} searchParams={searchParams}
                    searchValue={searchValue} setSearchValue={setSearchValue} loadLots={loadLots} isSearched={isSearched}
                    auctionData={auctionData} lotDetailsFromSocket={lotDetailsFromSocket}
                    handleDelete={handleDelete} loader={loader} isSocket={isSocket} loading={loading}
                    deleteLotModal={deleteLotModal} setDeleteLotModal={setDeleteLotModal} lotInfo={lotInfo} />
                :
                <LiveLotTable lots={liveLots.data} fetchHandler={fetchLiveLotsHandler}
                    handleSearch={handleSearch} handleSort={handleLiveSort} loader={loader}
                    currentSortColumn={currentSortColumn} searchParams={searchParams}
                    searchValue={searchValue} setSearchValue={setSearchValue} loadLots={loadLots}
                    auctionData={auctionData} handleDelete={deleteLiveLots} loading={loading}
                    deleteLotModal={deleteLotModal} setDeleteLotModal={setDeleteLotModal} lotInfo={liveLots} />
            )}
        </div>
    )
}